@if (isLoading()) {
  <app-shimmer-effect />
} @else {

  @if (!router.url.includes('level-details') && !router.url.includes('student-details')) {
    <section class="page-heading">
      <div>
        <h4>Academic Setup</h4>
        <small>Manage years, terms, levels and subjects</small>
      </div>

      <div class="btn-container">
        @if (isCurrentRoute('/dashboard/academic-management/academic-years')) {
          <button type="button" class="button" (click)="addAcademicYear.set(true)">
            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.99463 2.91443V11.0748" stroke="white" stroke-width="1.28234" />
              <path d="M2.91443 6.9946H11.0748" stroke="white" stroke-width="1.28234" />
            </svg>


            <p>Add academic year</p>
          </button>
        }

        @if (isCurrentRoute('/dashboard/academic-management/terms')) {
          <button class="button" (click)="addAcademicTerm.set(true)">
            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.99463 2.91443V11.0748" stroke="white" stroke-width="1.28234" />
              <path d="M2.91443 6.9946H11.0748" stroke="white" stroke-width="1.28234" />
            </svg>

            <p>Add a term</p>
          </button>
        }

        @if (isCurrentRoute('/dashboard/academic-management/levels') && admins.includes(loggedUserRole ?? '')) {
          <button type="button" class="button" (click)="addLevel.set(true)">
            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.99463 2.91443V11.0748" stroke="white" stroke-width="1.28234" />
              <path d="M2.91443 6.9946H11.0748" stroke="white" stroke-width="1.28234" />
            </svg>


            <p>Add a level</p>
          </button>
        }

        @if (isCurrentRoute('/dashboard/academic-management/subjects') && admins.includes(loggedUserRole ?? '')) {
          <button type="button" class="button" (click)="addSubject.set(true)">
            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.99463 2.91443V11.0748" stroke="white" stroke-width="1.28234" />
              <path d="M2.91443 6.9946H11.0748" stroke="white" stroke-width="1.28234" />
            </svg>

            <p>Add a subject</p>
          </button>
        }

        @if (isCurrentRoute('/dashboard/academic-management/students') && admins.includes(loggedUserRole ?? '')) {
          <button type="button" class="button" (click)="showAddStudent.set(true)">
            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.99463 2.91443V11.0748" stroke="white" stroke-width="1.28234" />
              <path d="M2.91443 6.9946H11.0748" stroke="white" stroke-width="1.28234" />
            </svg>

            <p>Enroll a student</p>
          </button>

        }

        @if (isCurrentRoute('/dashboard/academic-management/grade-configuration') && admins.includes(loggedUserRole ?? '')) {
          <button type="button" class="button" (click)="openConfigureTerm()">
            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.99463 2.91443V11.0748" stroke="white" stroke-width="1.28234" />
              <path d="M2.91443 6.9946H11.0748" stroke="white" stroke-width="1.28234" />
            </svg>

            <p>Configure term</p>
          </button>
        }

      </div>
    </section>

    <section class="data-cards">
      <div class="data-card level">
        <div class="top-heading">
          <div>
            <svg height="200px" width="200px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0 {
                fill: #238748;
              } </style>
                <g> <path class="st0"
                          d="M81.44,116.972c23.206,0,42.007-18.817,42.007-42.008c0-23.215-18.801-42.016-42.007-42.016 c-23.216,0-42.016,18.801-42.016,42.016C39.424,98.155,58.224,116.972,81.44,116.972z"></path>
                  <path class="st0"
                        d="M224.166,245.037c0-0.856-0.142-1.673-0.251-2.498l62.748-45.541c3.942-2.867,4.83-8.411,1.963-12.362 c-1.664-2.285-4.342-3.652-7.17-3.652c-1.877,0-3.667,0.589-5.191,1.689l-62.874,45.636c-2.341-1.068-4.909-1.704-7.65-1.704 h-34.178l-8.294-47.222c-4.555-23.811-14.112-42.51-34.468-42.51h-86.3C22.146,136.873,0,159.019,0,179.383v141.203 c0,10.178,8.246,18.432,18.424,18.432c5.011,0,0,0,12.864,0l7.005,120.424c0,10.83,8.788,19.61,19.618,19.61 c8.12,0,28.398,0,39.228,0c10.83,0,19.61-8.78,19.61-19.61l9.204-238.53h0.463l5.27,23.269c1.744,11.097,11.293,19.28,22.524,19.28 h51.534C215.92,263.461,224.166,255.215,224.166,245.037z M68.026,218.861v-67.123h24.126v67.123l-12.817,15.118L68.026,218.861z"></path>
                  <polygon class="st0"
                           points="190.326,47.47 190.326,200.869 214.452,200.869 214.452,71.595 487.874,71.595 487.874,302.131 214.452,302.131 214.452,273.113 190.326,273.113 190.326,326.256 512,326.256 512,47.47 "></polygon>
                  <path class="st0"
                        d="M311.81,388.597c0-18.801-15.235-34.029-34.028-34.029c-18.801,0-34.036,15.228-34.036,34.029 c0,18.785,15.235,34.028,34.036,34.028C296.574,422.625,311.81,407.381,311.81,388.597z"></path>
                  <path class="st0"
                        d="M277.781,440.853c-24.259,0-44.866,15.919-52.782,38.199h105.565 C322.648,456.771,302.04,440.853,277.781,440.853z"></path>
                  <path class="st0"
                        d="M458.573,388.597c0-18.801-15.235-34.029-34.028-34.029c-18.801,0-34.036,15.228-34.036,34.029 c0,18.785,15.235,34.028,34.036,34.028C443.338,422.625,458.573,407.381,458.573,388.597z"></path>
                  <path class="st0"
                        d="M424.545,440.853c-24.259,0-44.866,15.919-52.783,38.199h105.565 C469.411,456.771,448.804,440.853,424.545,440.853z"></path> </g> </g></svg>
          </div>
          <p>{{ dashboardData()?.levels?.active ?? 'No data' }} Active</p>
        </div>

        <h4>{{ dashboardData()?.levels?.total ?? 'No data' }}</h4>
        <p>Level(s)</p>
        <small>Year group levels</small>

        <div class="card-bg"></div>
      </div>

      <div class="data-card academic-year">
        <div class="top-heading">
          <div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.8333 3.33334H4.16667C3.24619 3.33334 2.5 4.07954 2.5 5.00001V16.6667C2.5 17.5872 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5872 17.5 16.6667V5.00001C17.5 4.07954 16.7538 3.33334 15.8333 3.33334Z"
                stroke="#5C0B13" stroke-width="1.41667" />
              <path d="M13.3334 1.66666V4.99999" stroke="#5C0B13" stroke-width="1.41667" />
              <path d="M6.66663 1.66666V4.99999" stroke="#5C0B13" stroke-width="1.41667" />
              <path d="M2.5 8.33334H17.5" stroke="#5C0B13" stroke-width="1.41667" />
            </svg>

          </div>
<!--          <p>1 Active</p>-->
        </div>

        <h4>{{ dashboardData()?.academicYears ?? 'No data' }}</h4>
        <p>Academic Year(s)</p>
        <small>Configured years</small>

        <div class="card-bg"></div>
      </div>

      <div class="data-card subject">
        <div class="top-heading">
          <div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.66663 2.5H6.66663C7.55068 2.5 8.39853 2.85119 9.02365 3.47631C9.64877 4.10143 9.99996 4.94928 9.99996 5.83333V17.5C9.99996 16.837 9.73657 16.2011 9.26773 15.7322C8.79889 15.2634 8.163 15 7.49996 15H1.66663V2.5Z"
                stroke="#1D4ED8" stroke-width="1.41667" />
              <path
                d="M18.3333 2.5H13.3333C12.4493 2.5 11.6014 2.85119 10.9763 3.47631C10.3512 4.10143 10 4.94928 10 5.83333V17.5C10 16.837 10.2634 16.2011 10.7322 15.7322C11.2011 15.2634 11.837 15 12.5 15H18.3333V2.5Z"
                stroke="#1D4ED8" stroke-width="1.41667" />
            </svg>

          </div>
          <p>{{ dashboardData()?.subjects?.active ?? 'No data' }} Active</p>
        </div>

        <h4>{{ dashboardData()?.subjects?.total ?? 'No data' }}</h4>
        <p>Subject(s)</p>
        <small>Across all levels</small>

        <div class="card-bg"></div>
      </div>


      <div class="data-card term">
        <div class="top-heading">
          <div>
            <svg viewBox="0 0 24 24" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <defs>
                  <style>.cls-1 {
                    fill: none;
                    stroke: #88701a;
                    stroke-miterlimit: 10;
                    stroke-width: 1.9px;
                  }</style>
                </defs>
                <polygon class="cls-1" points="21.5 9.15 12 14.85 2.5 9.15 12 3.45 21.5 9.15"></polygon>
                <line class="cls-1" x1="18.65" y1="10.88" x2="18.65" y2="15.8"></line>
                <path class="cls-1" d="M18.65,15.8v.95c0,2.1-3,3.8-6.65,3.8s-6.65-1.7-6.65-3.8V10.88"></path>
                <line class="cls-1" x1="12" y1="9.15" x2="15.8" y2="12.95"></line>
                <line class="cls-1" x1="15.8" y1="16.75" x2="15.8" y2="12.95"></line>
              </g>
            </svg>
          </div>
<!--          <p>{{ dashboardData()?.students ?? 'No data' }}</p>-->
        </div>

        <h4>{{ dashboardData()?.students ?? 'No data' }}</h4>
        <p>Student(s)</p>
        <small>Across all levels</small>

        <div class="card-bg"></div>
      </div>
    </section>

    <nav class="page-nav">
      <ul>
        @for (tab of visibleTabs(loggedUserRole ?? ''); track tab.route) {
          <li routerLinkActive="routerLinkActive" [routerLink]="tab.route">
            {{ tab.label }}
          </li>
        }
      </ul>
    </nav>
  }

  <router-outlet />

  @if (showAddStudent()) {
    <section class="pop-up">
      <div class="bg" (click)="showAddStudent.set(false)"></div>

      <form class="add-student-form" #studentForm="ngForm" (ngSubmit)="addStudent(studentForm)">
        <div class="form-heading">
          <div class="image-box">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.4865 13.1108V11.8622C12.4865 11.1998 12.2234 10.5646 11.7551 10.0963C11.2867 9.62798 10.6515 9.36487 9.98921 9.36487H4.99461C4.33229 9.36487 3.69709 9.62798 3.22876 10.0963C2.76042 10.5646 2.49731 11.1998 2.49731 11.8622V13.1108"
                stroke="white" stroke-width="1.37352" />
              <path
                d="M7.49193 6.86759C8.87115 6.86759 9.98923 5.74951 9.98923 4.37029C9.98923 2.99107 8.87115 1.87299 7.49193 1.87299C6.11271 1.87299 4.99463 2.99107 4.99463 4.37029C4.99463 5.74951 6.11271 6.86759 7.49193 6.86759Z"
                stroke="white" stroke-width="1.37352" />
            </svg>
          </div>

          <div>
            <h6>Add a Student</h6>
            <small>Enroll a student</small>
          </div>
        </div>

        <div class="form-container">

          <div>
            <label for="firstName">First Name <span class="required-check">*</span></label>
            <input required placeholder="e.g Naa Adoley" [(ngModel)]="firstName" type="text" name="firstName"
                   id="firstName">
          </div>

          <div>
            <label for="lastName">Last Name <span class="required-check">*</span></label>
            <input required placeholder="e.g. Sackey" [(ngModel)]="lastName" type="text" name="lastName" id="lastName">
          </div>

          <div>
            <label for="sex">Gender <span class="required-check">*</span></label>
            <select required [(ngModel)]="sex" name="sex" id="sex">
              <option value="" hidden>Select gender of student</option>
              <option value="MALE">Male</option>
              <option value="FEMALE">Female</option>
            </select>
          </div>

          <div>
            <label for="dob">Date of birth <span class="required-check">*</span></label>
            <input required [(ngModel)]="dob" type="date" name="dob" id="dob" [max]="todayDate">
          </div>

          <div>
            <label for="admissionDate">Admission Date <span class="required-check">*</span></label>
            <input required [(ngModel)]="admissionDate" type="date" name="admissionDate" id="admissionDate"
                   [max]="todayDate">
          </div>


          <div>
            <label for="admissionNumber">Admission Number <span class="required-check">*</span></label>
            <input required placeholder="e.g. ADM-2026-0001" [(ngModel)]="admissionNumber" type="text"
                   name="admissionNumber" id="admissionNumber">
          </div>

          <div>
            <label for="parentName">Name of Parent/Guardian <span class="required-check">*</span></label>
            <input required placeholder="e.g. Nii Adote Adotey" [(ngModel)]="parentName" type="text" name="parentName"
                   id="parentName">
          </div>

          <div>
            <label for="parentPhone">Phone Number of Parent/Guardian <span class="required-check">*</span></label>
            <input required placeholder="e.g. 050..." [(ngModel)]="parentPhone" type="text" name="parentPhone"
                   id="parentPhone">
          </div>

          <div>
            <label for="parentEmail">Email of Parent</label>
            <input placeholder="e.g. niiadotey@gmail.com" [(ngModel)]="parentEmail" type="email"
                   name="parentEmail" id="parentEmail">
          </div>

          <div class="btn-container">
            <button [disabled]="studentForm.invalid" class="secondary-button" type="submit">
              @if (isEditing()) {
                <app-loading-indicator></app-loading-indicator>
              } @else {
                Add Student
              }
            </button>
          </div>

        </div>

      </form>
    </section>
  }


  @if (addLevel()) {
    <section class="pop-up">
      <div class="bg" (click)="addLevel.set(false)"></div>

      <form #newLevelForm="ngForm" (ngSubmit)="createLevel(newLevelForm)">
        <div class="form-heading">
          <div class="image-box">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20.1567 9.16214V14.6594M20.1567 9.16214L10.9946 4.58105L1.8324 9.16214L10.9946 13.7432L20.1567 9.16214Z"
                stroke="white" stroke-width="1.55757" />
              <path d="M5.49731 10.9946V15.5757C8.24596 18.3244 13.7433 18.3244 16.4919 15.5757V10.9946" stroke="white"
                    stroke-width="1.55757" />
            </svg>
          </div>

          <div>
            <h6>Add a Level</h6>
            <small>Add a new academic level</small>
          </div>
        </div>

        <div class="form-container">
          <div>
            <label for="nameOfLevel">Name of Level <span class="required-check">*</span></label>
            <input placeholder="e.g.  Primary 4" required [(ngModel)]="nameOfLevel" type="text" name="nameOfLevel"
                   id="nameOfLevel">
          </div>

          <div>
            <label for="levelCode">Level Code <span class="required-check">*</span></label>
            <input placeholder="e.g.  PRI04" required [(ngModel)]="levelCode" type="text" name="levelCode"
                   id="levelCode">
          </div>

          <div>
            <label for="levelSequence">Level Sequence <span class="required-check">*</span></label>
            <input placeholder="Select a numbered order for this level. e.g. 1" required [(ngModel)]="levelSequence"
                   type="number" name="levelSequence" id="levelSequence">
          </div>

          <div>
            <label for="levelDescription">Description</label>
            <input placeholder="e.g.  Add an optional description..." [(ngModel)]="levelDescription" type="text"
                   name="levelDescription" id="levelDescription">
          </div>

          <button class="secondary-button" type="submit" [disabled]="newLevelForm.invalid">
            @if (isEditing()) {
              <app-loading-indicator></app-loading-indicator>
            } @else {
              Add Level
            }
          </button>
        </div>
      </form>
    </section>
  }

  @if (addSubject()) {
    <section class="pop-up">
      <div class="bg" (click)="addSubject.set(false)"></div>

      <form #newSubjectForm="ngForm" (ngSubmit)="createSubject(newSubjectForm)">
        <div class="form-heading">
          <div class="image-box">
            <svg fill="#fff" height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g> <g> <path
                d="M486.881,38.48H25.119C11.268,38.48,0,49.748,0,63.599v384.802c0,13.851,11.268,25.119,25.119,25.119h461.762 c13.851,0,25.119-11.268,25.119-25.119V63.599C512,49.748,500.732,38.48,486.881,38.48z M426.489,54.514h26.722v26.722h-26.722 V54.514z M383.733,54.514h26.722v26.722h-26.722V54.514z M58.789,54.514h308.91v26.722H58.789V54.514z M16.033,63.599 c0-5.01,4.076-9.086,9.086-9.086h17.637v26.722H16.033V63.599z M495.967,448.401c0,5.01-4.076,9.086-9.086,9.086H25.119 c-5.01,0-9.086-4.076-9.086-9.086V97.269h479.933V448.401z M495.967,81.236h-26.722V54.514h17.637c5.01,0,9.086,4.076,9.086,9.086 V81.236z"></path> </g> </g>
                <g> <g> <path
                  d="M461.228,115.44H50.772c-9.136,0-16.568,7.432-16.568,16.568v119.716c0,9.136,7.432,16.568,16.568,16.568h410.455 c9.136,0,16.568-7.432,16.568-16.568V132.008C477.795,122.872,470.363,115.44,461.228,115.44z M162.472,252.259H50.772 c-0.295,0-0.534-0.239-0.534-0.534V132.008c0-0.295,0.239-0.534,0.534-0.534h111.699V252.259z M461.762,251.724 c0,0.295-0.239,0.534-0.534,0.534H178.505V131.474h282.722c0.295,0,0.534,0.239,0.534,0.534V251.724z"></path> </g> </g>
                <g> <g> <path
                  d="M461.228,286.464H50.772c-9.136,0-16.568,7.432-16.568,16.568v119.716c0,9.136,7.432,16.568,16.568,16.568h410.455 c9.136,0,16.568-7.432,16.568-16.568V303.031C477.795,293.896,470.363,286.464,461.228,286.464z M162.472,423.282H50.772 c-0.295,0-0.534-0.239-0.534-0.534V303.031c0-0.295,0.239-0.534,0.534-0.534h111.699V423.282z M461.762,422.747 c0,0.295-0.239,0.534-0.534,0.534H178.505V302.497h282.722c0.295,0,0.534,0.239,0.534,0.534V422.747z"></path> </g> </g>
                <g> <g> <path
                  d="M136.284,158.196h-21.912v-0.534c0-4.427-3.589-8.017-8.017-8.017s-8.017,3.589-8.017,8.017v0.534H76.426 c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h35.375c-0.781,4.921-2.347,11.576-5.446,18.443 c-0.532-1.184-1.045-2.389-1.52-3.636c-1.576-4.138-6.207-6.213-10.345-4.64c-4.138,1.576-6.215,6.207-4.64,10.345 c1.797,4.719,3.975,9.12,6.49,13.194c-3.924,4.211-8.782,8.004-14.832,10.908c-3.991,1.915-5.674,6.704-3.758,10.696 c1.379,2.873,4.246,4.549,7.233,4.549c1.163,0,2.344-0.254,3.463-0.792c7.204-3.458,13.111-7.806,17.963-12.616 c5.192,5.159,11.169,9.407,17.854,12.616c1.119,0.537,2.3,0.792,3.463,0.792c2.986,0,5.854-1.677,7.233-4.549 c1.915-3.991,0.233-8.78-3.758-10.696c-5.656-2.714-10.585-6.339-14.786-10.82c7.702-12.508,10.547-25.642,11.595-33.794h8.273 c4.427,0,8.017-3.589,8.017-8.017C144.301,161.785,140.711,158.196,136.284,158.196z"></path> </g> </g>
                <g> <g> <path
                  d="M144.061,395.15l-15.483-61.933c-1.848-7.388-8.457-12.549-16.073-12.549h-12.301c-7.616,0-14.226,5.161-16.073,12.55 L68.649,395.15c-1.074,4.296,1.537,8.647,5.833,9.722c4.292,1.076,8.648-1.537,9.722-5.833l2.757-11.03h38.789l2.758,11.03 c0.911,3.643,4.179,6.075,7.771,6.075c0.643,0,1.298-0.078,1.951-0.242C142.523,403.797,145.135,399.446,144.061,395.15z M90.968,371.975l8.717-34.868c0.06-0.239,0.273-0.405,0.518-0.405h12.301c0.246,0,0.46,0.167,0.518,0.404l8.719,34.869H90.968z"></path> </g> </g>
                <g> <g> <path
                  d="M298.756,158.196h-85.511c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h85.511 c4.427,0,8.017-3.589,8.017-8.017S303.183,158.196,298.756,158.196z"></path> </g> </g>
                <g> <g> <path
                  d="M367.165,192.401H213.244c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h153.921 c4.427,0,8.017-3.589,8.017-8.017S371.592,192.401,367.165,192.401z"></path> </g> </g>
                <g> <g> <path
                  d="M401.37,158.196H332.96c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h68.409 c4.427,0,8.017-3.589,8.017-8.017S405.797,158.196,401.37,158.196z"></path> </g> </g>
                <g> <g> <path
                  d="M281.653,329.219h-68.409c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h68.409 c4.427,0,8.017-3.589,8.017-8.017S286.081,329.219,281.653,329.219z"></path> </g> </g>
                <g> <g> <path
                  d="M332.96,363.424H213.244c-4.427,0-8.017,3.589-8.017,8.017c0,4.427,3.589,8.017,8.017,8.017H332.96 c4.427,0,8.017-3.589,8.017-8.017C340.977,367.013,337.388,363.424,332.96,363.424z"></path> </g> </g>
                <g> <g> <path
                  d="M384.267,329.219h-68.409c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h68.409 c4.427,0,8.017-3.589,8.017-8.017S388.695,329.219,384.267,329.219z"></path> </g> </g> </g></svg>
          </div>
          <div>
            <h6>Add a Subject</h6>
            <small>Add a new subject</small>
          </div>
        </div>

        <div class="form-container">
          <div>
            <label for="nameOfSubject">Name of Subject <span class="required-check">*</span></label>
            <input placeholder="e.g. Mathematics" required [(ngModel)]="nameOfSubject" type="text" name="nameOfSubject"
                   id="nameOfSubject">
          </div>

          <div>
            <label for="subjectCode">Code <span class="required-check">*</span></label>
            <input placeholder="e.g. MATH 101" required [(ngModel)]="subjectCode" type="text" name="subjectCode"
                   id="subjectCode">
          </div>

          <div>
            <label for="subjectDescription">Description</label>
            <input placeholder="e.g. The study of numbers, shapes, quantities, and patterns..."
                   [(ngModel)]="subjectDescription"
                   type="text" name="subjectDescription" id="subjectDescription">
          </div>

          <button class="secondary-button" type="submit" [disabled]="newSubjectForm.invalid">
            @if (isEditing()) {
              <app-loading-indicator />
            } @else {
              Add Subject
            }
          </button>

        </div>
      </form>
    </section>
  }

  @if (addAcademicYear()) {
    <section class="pop-up">
      <div class="bg" (click)="addAcademicYear.set(false)"></div>

      <form #academicYearForm="ngForm" (ngSubmit)="createAcademicYear(academicYearForm)">
        <div class="form-heading">
          <div class="image-box">
            <svg fill="#fff" height="200px" width="200px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 318.331 318.331" xml:space="preserve"
                 stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <path
                d="M310.331,305.092H8c-4.418,0-8-3.582-8-8V109.059c0-4.418,3.582-8,8-8s8,3.582,8,8v180.033h286.331V109.059 c0-4.418,3.582-8,8-8s8,3.582,8,8v188.033C318.331,301.51,314.749,305.092,310.331,305.092z M261.634,269.336h-18.242 c-4.418,0-8-3.582-8-8s3.582-8,8-8h18.242c4.418,0,8,3.582,8,8S266.052,269.336,261.634,269.336z M143.252,269.336h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S147.67,269.336,143.252,269.336z M74.941,269.336H38.455 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.486c4.418,0,8,3.582,8,8S79.359,269.336,74.941,269.336z M279.877,239.262h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S284.295,239.262,279.877,239.262z M211.565,239.262H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,239.262,211.565,239.262z M143.252,208.234h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S147.67,208.234,143.252,208.234z M74.941,208.234H38.455 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.486c4.418,0,8,3.582,8,8v30.073 C82.941,204.653,79.359,208.234,74.941,208.234z M46.455,192.234h20.486v-14.073H46.455V192.234z M211.565,178.161H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,178.161,211.565,178.161z M279.877,147.132h-36.485 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.485c4.418,0,8,3.582,8,8v30.073 C287.877,143.551,284.295,147.132,279.877,147.132z M251.392,131.132h20.485v-14.073h-20.485V131.132z M143.252,147.132h-36.485 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.485c4.418,0,8,3.582,8,8v30.073 C151.252,143.551,147.67,147.132,143.252,147.132z M114.767,131.132h20.485v-14.073h-20.485V131.132z M211.565,117.059H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,117.059,211.565,117.059z M74.941,117.059H38.455 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.486c4.418,0,8,3.582,8,8S79.359,117.059,74.941,117.059z M310.331,82.385H8 c-4.418,0-8-3.582-8-8V33.33c0-4.418,3.582-8,8-8h18.171c4.418,0,8,3.582,8,8s-3.582,8-8,8H16v25.056h286.331V41.33h-10.226 c-4.418,0-8-3.582-8-8s3.582-8,8-8h18.226c4.418,0,8,3.582,8,8v41.056C318.331,78.804,314.749,82.385,310.331,82.385z M266.919,53.42c-4.418,0-8-3.582-8-8V21.239c0-4.418,3.582-8,8-8s8,3.582,8,8V45.42C274.919,49.839,271.337,53.42,266.919,53.42z M51.413,53.42c-4.418,0-8-3.582-8-8V21.239c0-4.418,3.582-8,8-8s8,3.582,8,8V45.42C59.413,49.839,55.831,53.42,51.413,53.42z M242.53,41.33H77.055c-4.418,0-8-3.582-8-8s3.582-8,8-8H242.53c4.418,0,8,3.582,8,8S246.948,41.33,242.53,41.33z"></path> </g></svg>
          </div>
          <div>
            <h6>Add an Academic Year</h6>
            <small>Add a new academic year</small>
          </div>
        </div>

        <div class="form-container">
          <div>
            <label for="academicYearName">Academic Year <span class="required-check">*</span></label>
            <input required [(ngModel)]="academicYearName" type="text" name="academicYearName" id="academicYearName"
                   placeholder="eg. 2026/2027">
          </div>

          <div class="form-group">
            <div>
              <label for="startDate">Start Date <span class="required-check">*</span></label>
              <input required [(ngModel)]="startDate" type="date" name="startDate" id="startDate">
            </div>

            <div>
              <label for="endDate">End Date <span class="required-check">*</span></label>
              <input required [(ngModel)]="endDate" type="date" name="endDate" id="endDate">
            </div>
          </div>

          <div>
            <label for="academicYearStatus">Academic Year Status <span class="required-check">*</span></label>

            <select required [(ngModel)]="academicYearStatus" type="text" name="academicYearStatus"
                    id="academicYearStatus">
              <option value="" hidden disabled>Select a status</option>
              <option value="ACTIVE">Active</option>
              <option value="UPCOMING">Upcoming</option>
            </select>
          </div>

          @if (academicYearStatus === 'ACTIVE') {
            <div class="checkbox">
              <input [(ngModel)]="currentAcademicYear" type="checkbox" name="currentAcademicYear"
                     id="currentAcademicYear">
              <label for="currentAcademicYear">Set as current academic year</label>
            </div>
          }

          <button class="secondary-button" [disabled]="academicYearForm.invalid">
            @if (isEditing()) {
              <app-loading-indicator></app-loading-indicator>
            } @else {
              Add academic year
            }
          </button>
        </div>

      </form>
    </section>
  }

  @if (addAcademicTerm()) {
    <section class="pop-up">
      <div class="bg" (click)="addAcademicTerm.set(false)"></div>

      <form #academicTermForm="ngForm" (ngSubmit)="createAcademicTerm(academicTermForm)">
        <div class="form-heading">
          <div class="image-box">
            <svg fill="#fff" height="200px" width="200px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 318.331 318.331" xml:space="preserve"
                 stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <path
                d="M310.331,305.092H8c-4.418,0-8-3.582-8-8V109.059c0-4.418,3.582-8,8-8s8,3.582,8,8v180.033h286.331V109.059 c0-4.418,3.582-8,8-8s8,3.582,8,8v188.033C318.331,301.51,314.749,305.092,310.331,305.092z M261.634,269.336h-18.242 c-4.418,0-8-3.582-8-8s3.582-8,8-8h18.242c4.418,0,8,3.582,8,8S266.052,269.336,261.634,269.336z M143.252,269.336h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S147.67,269.336,143.252,269.336z M74.941,269.336H38.455 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.486c4.418,0,8,3.582,8,8S79.359,269.336,74.941,269.336z M279.877,239.262h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S284.295,239.262,279.877,239.262z M211.565,239.262H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,239.262,211.565,239.262z M143.252,208.234h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S147.67,208.234,143.252,208.234z M74.941,208.234H38.455 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.486c4.418,0,8,3.582,8,8v30.073 C82.941,204.653,79.359,208.234,74.941,208.234z M46.455,192.234h20.486v-14.073H46.455V192.234z M211.565,178.161H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,178.161,211.565,178.161z M279.877,147.132h-36.485 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.485c4.418,0,8,3.582,8,8v30.073 C287.877,143.551,284.295,147.132,279.877,147.132z M251.392,131.132h20.485v-14.073h-20.485V131.132z M143.252,147.132h-36.485 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.485c4.418,0,8,3.582,8,8v30.073 C151.252,143.551,147.67,147.132,143.252,147.132z M114.767,131.132h20.485v-14.073h-20.485V131.132z M211.565,117.059H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,117.059,211.565,117.059z M74.941,117.059H38.455 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.486c4.418,0,8,3.582,8,8S79.359,117.059,74.941,117.059z M310.331,82.385H8 c-4.418,0-8-3.582-8-8V33.33c0-4.418,3.582-8,8-8h18.171c4.418,0,8,3.582,8,8s-3.582,8-8,8H16v25.056h286.331V41.33h-10.226 c-4.418,0-8-3.582-8-8s3.582-8,8-8h18.226c4.418,0,8,3.582,8,8v41.056C318.331,78.804,314.749,82.385,310.331,82.385z M266.919,53.42c-4.418,0-8-3.582-8-8V21.239c0-4.418,3.582-8,8-8s8,3.582,8,8V45.42C274.919,49.839,271.337,53.42,266.919,53.42z M51.413,53.42c-4.418,0-8-3.582-8-8V21.239c0-4.418,3.582-8,8-8s8,3.582,8,8V45.42C59.413,49.839,55.831,53.42,51.413,53.42z M242.53,41.33H77.055c-4.418,0-8-3.582-8-8s3.582-8,8-8H242.53c4.418,0,8,3.582,8,8S246.948,41.33,242.53,41.33z"></path> </g></svg>
          </div>
          <div>
            <h6>Add an Academic Term</h6>
            <small>Add a new academic term</small>
          </div>
        </div>

        <div class="form-container">

          <div>
            <label for="academicYearId">Academic Year <span class="required-check">*</span></label>
            <select (change)="getAcademicYear(academicYearId)" required [(ngModel)]="academicYearId"
                    name="academicYearId" id="academicYearId">
              <option value="">Select an academic year</option>

              @for (a of academicYears()?.payload; track a.id) {
                @if (!invalidStatuses.includes(a.status)) {
                  <option [value]="a.id">{{ a.name }}</option>
                }
              }
            </select>
          </div>

          @if (showTerms()) {
          <div>
            <label for="academicTermName">Academic Term <span class="required-check">*</span></label>

            <select required [(ngModel)]="academicTermName" type="text" name="academicTermName" id="academicTermName">
              <option value="" hidden disabled>Select a term name</option>

              @for (term of academicTerms; track term) {
                @if (!termExists(term)) {
                  <option [value]="term">{{ term }}</option>
                }
              }
            </select>
          </div>
          }

          <div class="form-group">
            <div>
              <label for="startDate">Start Date <span class="required-check">*</span></label>
              <input required [(ngModel)]="termStartDate" type="date" name="startDate" id="startDate">
            </div>

            <div>
              <label for="endDate">End Date <span class="required-check">*</span></label>
              <input required [(ngModel)]="termEndDate" type="date" name="endDate" id="endDate">
            </div>
          </div>

          <div>
            <label for="academicTermStatus">Term Status <span class="required-check">*</span></label>

            <select required [(ngModel)]="academicTermStatus" type="text" name="academicTermStatus"
                    id="academicTermStatus">
              <option value="" hidden disabled>Select a status</option>

              <option value="ACTIVE">Active</option>
              <option value="UPCOMING">Upcoming</option>
            </select>
          </div>


          @if (academicTermStatus === 'ACTIVE') {
            <div class="checkbox">
              <input [(ngModel)]="currentAcademicTerm" type="checkbox" name="currentAcademicTerm"
                     id="currentAcademicTerm">
              <label for="currentAcademicTerm">Set as current academic term</label>
            </div>
          }

          @if (academicYear() !== null && showTerms()) {
            <div class="note">

              <div class="shield-box"><img src="/auth/warning-icon.png" alt="warning image"></div>

              <div>
                <p>Start & End dates must fall strictly within the boundaries of the parent Academic Year
                  ({{ Helpers.formatDate(academicYear()?.payload?.start_date) }}
                  - {{ Helpers.formatDate(academicYear()?.payload?.end_date) }}).</p>
              </div>
            </div>
          }

          <button class="secondary-button add-term-btn" [disabled]="academicTermForm.invalid">
            @if (isEditing()) {
              <app-loading-indicator></app-loading-indicator>
            } @else {
              Add academic term
            }
          </button>
        </div>

      </form>
    </section>
  }

  @if (configureTerm()) {
    <section class="pop-up">
      <div class="bg" (click)="closeConfigureTerm()"></div>

      <form #configureTermForm="ngForm" (ngSubmit)="configureTermGradeSystem(configureTermForm)">
        <div class="form-heading">
          <div class="image-box">
            <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" fill="#fff" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="#fff" d="M13.94 3.68a1.64 1.64 0 0 0-.83-1.05 1.71 1.71 0 0 0-.49-1.25 1.665 1.665 0 0 0-1.25-.49A1.678 1.678 0 0 0 9 .26a1.678 1.678 0 0 0-2.37.63 1.665 1.665 0 0 0-1.25.49 1.71 1.71 0 0 0-.49 1.25A1.678 1.678 0 0 0 4.26 5a1.678 1.678 0 0 0 .63 2.37 1.71 1.71 0 0 0 .49 1.25 1.628 1.628 0 0 0 1.25.49 1.393 1.393 0 0 0 .37.46v8.15a.264.264 0 0 0 .07.19.214.214 0 0 0 .18.09.234.234 0 0 0 .17-.07l.01-.01L9 16.5l1.58 1.43a.234.234 0 0 0 .17.07.214.214 0 0 0 .18-.09.264.264 0 0 0 .07-.19V9.57a1.393 1.393 0 0 0 .37-.46 1.628 1.628 0 0 0 1.25-.49 1.71 1.71 0 0 0 .49-1.25A1.678 1.678 0 0 0 13.74 5a1.64 1.64 0 0 0 .2-1.32zM9 7a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"></path> </g></svg>
          </div>
          <div>
            <h6>Configure Term</h6>
            <small>Assign a class and exam score weight to levels in a term</small>
          </div>
        </div>

        <div class="form-container">

          <div>
            <label for="configureScoreWeight">Score Weight <span class="required-check">*</span></label>
            <select
              name="configureScoreWeight"
              id="configureScoreWeight"
              [(ngModel)]="assignScoreWeightId"
              [disabled]="isLoadingScoreWeights()"
              required
            >
              <option value="" disabled>
                {{ isLoadingScoreWeights() ? 'Loading score weights...' : 'Select score weight' }}
              </option>
              @for (weight of scoreWeights()?.payload ?? []; track weight.id) {
                @if (weight.status === 'ACTIVE') {
                  <option [value]="weight.id">
                    {{ weight.configuration_name }} (Class {{ weight.class_score }} / Exam
                    {{ weight.examination_score }})
                  </option>
                }
              }
            </select>
          </div>

          <div>
            <label for="configureGradingSystem">Grading System <span class="required-check">*</span></label>
            <select
              name="configureGradingSystem"
              id="configureGradingSystem"
              [(ngModel)]="assignGradingSystemId"
              [disabled]="isLoadingScoreWeights()"
              required
            >
              <option value="" disabled>
                {{ isLoadingScoreWeights() ? 'Loading score weights...' : 'Select score weight' }}
              </option>
              @for (weight of gradingSystems()?.payload ?? []; track weight.id) {
                @if (weight.status === 'ACTIVE') {
                  <option [value]="weight.id">
                    {{ weight.name }}
                  </option>
                }
              }
            </select>
          </div>

          <div>
            <label for="configureAcademicYear">Academic Year <span class="required-check">*</span></label>
            <select
              name="configureAcademicYear"
              id="configureAcademicYear"
              [(ngModel)]="assignAcademicYearId"
              (ngModelChange)="onAssignAcademicYearChange($event)"
              [disabled]="isLoadingAssignAcademicYears()"
              required
            >
              <option value="" disabled>
                {{ isLoadingAssignAcademicYears() ? 'Loading academic years...' : 'Select academic year' }}
              </option>
              @for (year of assignAcademicYears()?.payload ?? []; track year.id) {
                <option [value]="year.id">{{ year.name }}</option>
              }
            </select>
          </div>

          <div>
            <label for="configureTerm">Term <span class="required-check">*</span></label>
            <select
              name="configureTerm"
              id="configureTerm"
              [(ngModel)]="assignTermId"
              [disabled]="!assignAcademicYearId || isLoadingAssignTerms()"
              required
            >
              <option value="" disabled>
                @if (isLoadingAssignTerms()) {
                  Loading terms...
                } @else if (!assignAcademicYearId) {
                  Select an academic year first
                } @else {
                  Select term
                }
              </option>
              @for (term of assignAcademicTerms()?.payload ?? []; track term.id) {
                <option [value]="term.id">{{ term.term_name }}</option>
              }
            </select>
          </div>

          <div class="levels-field">
            <label>Select Levels <span class="required-check">*</span></label>

            <div class="levels-grid">
              <div
                class="level-option select-all"
                [class.selected]="areAllAssignLevelsSelected"
                (click)="selectAllAssignLevels()"
              >
                <div class="level-checkbox">
                  @if (areAllAssignLevelsSelected) {
                    <span>&#10003;</span>
                  }
                </div>

                <span class="level-name">Select All</span>
              </div>

              @for (level of assignLevels()?.payload ?? []; track level.id) {
                <div
                  class="level-option"
                  [class.selected]="assignLevelIds.includes(level.id)"
                  (click)="toggleAssignLevel(level.id)"
                >
                  <div class="level-checkbox">
                    @if (assignLevelIds.includes(level.id)) {
                      <span>&#10003;</span>
                    }
                  </div>

                  <span class="level-name">{{ level.name }}</span>
                </div>
              }
            </div>

            @if (isLoadingAssignLevels()) {
              <small>Loading levels...</small>
            }
          </div>

          <button
            class="secondary-button add-term-btn"
            [disabled]="configureTermForm.invalid || !assignLevelIds.length || isAssigningToTerm()"
          >
            @if (isAssigningToTerm()) {
              <app-loading-indicator></app-loading-indicator>
            } @else {
              Configure Term
            }
          </button>
        </div>

      </form>
    </section>
  }

}




